import * as Solr from "../../../3x1010/Solr.js";
import PageCommon from "../../PageCommon.js";

export default class TreeResultsProvider {
  constructor(qb, type) {
    this.qb = qb;
    this.lastRq = null;
    this.type = type;
    TreeResultsProvider.that = this;
  }

  reset() {
    this.lastRq = null;
  }

  getRows(params) {
    //PageCommon.that.showPreloader(true);
    let rq;

    rq = {
      id: params.parentNode?.data?.id ? params.parentNode?.data?.id : "",
      loadChildreen: true,
    };
    console.log(rq);
    thatServiceManeger.standardCall("/api/solr/tree/get_node?id=" + rq.id + "&loadChildreen=" + rq.loadChildreen, null, this.onTrySearchHandler.bind(this, params), "GET");
  }

  onTrySearchHandler(params, data) {
    console.log(params);
    console.log(data);

    if (!data) {
      params.fail();
      //PageCommon.that.showPreloader(false);
      return;
    }
    if (data.Success) {
      //data.data.children = data.data.Children;
      data.data.group = true;

      //const rows = [data.data];
      let rows = data.data.children;
      // Li filtra in base al ruolo

      const roles = TheApp.CurrentContext.userSession.userData.usr.Roles;
      if (roles.indexOf("SUPERADMIN") === -1) {
        // Utente normale
        const a = roles.split(",");
        if (Solr.Schema.INCLUDE_FILMOGRAFIA) {
          a.push("FILMOGRAFIA_coll");
        }

        const tmp = [];
        for (let x = 0; x < rows.length; x++) {
          let coll = rows[x].type.split("/");
          coll = coll[coll.length - 1];
          if (a.indexOf(coll) !== -1) {
            tmp.push(rows[x]);
          }
        }
        rows = tmp;
      }

      setTimeout(() => {
        //PageCommon.that.showPreloader(false);
        params.success({ rowData: rows }), 100;
      });
    } else {
      params.fail();
      //PageCommon.that.showPreloader(false);
    }
  }
}

TreeResultsProvider.DEFAULT_ROWS_REQUESTED_TO_SERVER = 100;
TreeResultsProvider.DEFAULT_SORT_ORDER = "id desc";

TreeResultsProvider.SEARCH_TYPE_ADVANCED = "advanced";
TreeResultsProvider.SEARCH_TYPE_FULLTEXT = "fulltext";
TreeResultsProvider.SEARCH_TYPE_ONFIELD = "onefield";

TreeResultsProvider.SEARCH_TYPE_FULLTEXT_MODE = "tPHRASEw"; // meglio questo
TreeResultsProvider.SEARCH_TYPE_ONFIELD_MODE = "tPHRASEw"; // SBAGLIATO!!!!! va preso in base al tipo di campo (il primo restituito da getOperatorsForType)

// QueryNodeCompareType.tPHRASE = "tPHRASE";
// QueryNodeCompareType.tPHRASEw = "tPHRASEw";
// QueryNodeCompareType.tALLTERMS = "tALLTERMS";
// QueryNodeCompareType.tALLTERMSw = "tALLTERMSw";
// QueryNodeCompareType.tANYTERM = "tANYTERM";
// QueryNodeCompareType.tANYTERMw = "tANYTERMw";
